"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const select_input_1 = __importDefault(require("../select-input"));
const MultiSelectInput = (props) => (react_1.default.createElement(select_input_1.default, Object.assign({}, props, { multiSelect: true })));
exports.default = MultiSelectInput;
//# sourceMappingURL=index.js.map